export default __webpack_public_path__ + "578f745.png";